// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  judgeWinSize();
  setHeader();
  setSpan();
  // setInview();
  setAcc();
  // setMegaMenu();
  // startScroll();
  setMainMenu();
  setLoaded();
  setTimeout(() => {
    startScroll();
  }, 500);
  if ($('#wrapper').hasClass('home')) {
    switchMovie();
    setKvVideo();
    setClock();
    setSlider_01();
    setSlider_02();
  } else if ($('#wrapper').hasClass('rooms')) {
    switchMovie();
    setKvVideo();
    setSlider_01();
    setFancy();
  } else if ($('#wrapper').hasClass('foods')) {
    switchMovie();
    setKvVideo();
    setSlider_01();
    setSlider_03();
  } else if ($('#wrapper').hasClass('facility')) {
    switchMovie();
    setKvVideo();
    setSlider_01();
  } else if ($('#wrapper').hasClass('activities')) {
    switchMovie();
    setKvVideo();
    setSlider_04();
  } else if ($('#wrapper').hasClass('tourist')) {
    setSlider_01();
    setSlider_02();
    setSlider_05();
    setSlider_06();
    setCurrent();
  } else if ($('#wrapper').hasClass('onsen')) {
    switchMovie();
    setKvVideo();
    setSlider_01();
  } else if ($('#wrapper').hasClass('contact')) {
    setForm();
  } else if ($('#wrapper').hasClass('access')) {
    setScrollHint();
    setTab();
    setSlider_02();
    setModal();
  }
  setWay();
  // setRellax();
  mailTo();
  setReserveBtn();
  setDatePicker();
  setSearchTab();
  heightLineGroup();
  // setBlobsSlide(6000);
});

var current_scrollY = 0;

//カレント制御
function setCurrent() {
  $('.setCurrent a').each(function () {
    if ($(this).hasClass('current')) {
      $(this).parents('.swiper-slide').remove();
    }
  });
  $('.js-modelCouse a').each(function () {
    if ($(this).hasClass('current')) {
      $(this).parents('.articleStyle_09').remove();
    }
  });
}

//動画のスマホ切り替え
function switchMovie() {
  // 切り替える対象にclass属性。
  var $elem = $('.switch');

  // 切り替えの対象のsrc属性の末尾の文字列。
  var sp = '_sp.';
  var pc = '_pc.';

  // 画像を切り替えるウィンドウサイズ。
  var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt($(window).width());

    // ページ内にあるすべての`.switch`に適応される。
    $elem.each(function () {
      var $this = $(this);
      var $poster = $(this).parent();
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if (windowWidth > replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));

        // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
      const myvideo = $(this).parent().get(0);
      myvideo.load();
      myvideo.play();
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    } else {
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearInterval(timer);
      }
      timer = setTimeout(function () {
        imageSwitch();
      }, 200);
    }
  });
}

//KV動画
function setKvVideo() {
  // $('#kvVideo').get(0).play();
  // document.getElementById('video').addEventListener('loadeddata', function () {
  //   console.log('loadeddata発生');
  // });
  var videoElem = document.getElementById('kvVideo');
  videoElem.addEventListener('loadedmetadata', function () {
    $('#wrapper').addClass('videoReady');
    timer = setTimeout(function () {
      $('#wrapper').addClass('videoActive');
    }, 600);
  });

  // videoElem.addEventListener('timeupdate', seekbar, false);

  // function seekbar() {
  //   var fullTime = videoElem.duration; // 動画全体の時間
  //   var nowTime = videoElem.currentTime; // 現在の再生時間
  //   var setPos = (nowTime / fullTime) * 100; // 全体に対する現在の位置

  //   $('#kvSeek').css({ width: setPos + '%' });
  // }
}

//日時
function setClock() {
  const clock = () => {
    // 現在の日時・時刻の情報を取得
    const d = new Date();

    // 年を取得
    let year = d.getFullYear();
    // 月を取得
    let monthNum = d.getMonth();
    const monthday = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'Octber',
      'November',
      'December',
    ];
    let month = monthday[monthNum];
    // 日を取得
    let date = d.getDate();
    // // 曜日を取得
    // let dayNum = d.getDay();
    // const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // let day = weekday[dayNum];
    // // 時を取得
    // let hour24 = d.getHours();
    // let hour12 = hour24 % 12;
    // let hourStr = hour24 < 12 ? 'AM' : 'PM';
    // let hour = hour12;
    // // 分を取得
    // let min = d.getMinutes();
    // // 秒を取得
    // let sec = d.getSeconds();

    // 1桁の場合は0を足して2桁に
    date = date < 10 ? '0' + date : date;
    // hour = hour < 10 ? '0' + hour : hour;
    // min = min < 10 ? '0' + min : min;
    // sec = sec < 10 ? '0' + sec : sec;

    // 日付・時刻の文字列を作成
    let today = `${month} ${date}, ${year} `;
    // let today = `${day}\n${date} ${month} ${year} `;
    // let time1 = `${hour}`;
    // let time2 = `${min} ${hourStr}`;

    // 文字列を出力
    document.querySelector('.clock-date').innerText = today;
    // document.querySelector('.clock-hour').innerText = time1;
    // document.querySelector('.clock-ot').innerText = time2;
  };

  // 1秒ごとにclock関数を呼び出す
  setInterval(clock, 1000);
}

//タブ制御
function setTab() {
  $('.tabNav_01 li').on('click', function () {
    if (!$(this).hasClass('active')) {
      var target = '.' + $(this).attr('class').replace('active ', '');
      $(this).parents('.tabNav_01').find('li').removeClass('active');
      $(this).addClass('active');
      $(this).parents('.tabNav_01').next().find('.item').removeClass('active').hide();
      $(target).fadeIn();
    }
  });
}

//スクロールヒント
function setScrollHint() {
  $('.scrollHintSec').scroll(function () {
    $(this).parent().find('.scroll-hint-icon-wrap').fadeOut();
    // スクロールしたときの処理内容を記述する
  });
  // new ScrollHint('.js-scrollHint', {
  //   i18n: {
  //     scrollable: 'スクロールできます',
  //   },
  // });
}

// /////フォーム制御
function setForm() {
  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr(
    'onkeyup',
    'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")'
  );

  $('.optBtn').on('click', function () {
    $(this).toggleClass('is-check');
    $('#confirmBtn').toggleClass('dis');
  });
  // $('input[name="acceptance-form"]').change(function () {
  //   var prop = $(this).prop('checked');
  //   if (prop) {
  //     $('#confirmBtn').removeClass('off');
  //   } else {
  //     $('#confirmBtn').addClass('off');
  //   }
  // });

  $('#js-count').keyup(function () {
    var count = $(this).val().length;
    $('.show-count').text(count);
  });

  $('#confirmBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7-previous').click();
  });
  $('#sendBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  /////エラーのとき
  document.addEventListener(
    'wpcf7invalid',
    function (event) {
      setTimeout(function () {
        var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
        $('html,body').animate(
          {
            scrollTop: position,
          },
          {
            queue: false,
          }
        );
      }, 100);
    },
    false
  );
  // // /////成功のとき
  // document.addEventListener(
  //   'wpcf7mailsent',
  //   function (event) {
  //     $('html,body').animate(
  //       {
  //         scrollTop: 0,
  //       },
  //       {
  //         queue: false,
  //       }
  //     );
  //   },
  //   false
  // );

  // var urlHash = location.search;
  // // URLにアンカーが存在する場合
  // if (urlHash) {
  //   urlHash = urlHash.replace('?subject_', '');
  //   var target = '.subjectSelect .wpcf7-list-item:nth-child(' + urlHash + ') label';
  //   target = $(target);
  //   target.click();
  // }
}

//fancyBox
function setFancy() {
  $('.setFancy').fancybox({
    // オプションを下記に記載していきます
    // animationEffect: 'zoom-in-out', //アニメーションをズームインアウトに
    // loop: true, // 複数画像表示時に最初と最後をループさせる
    toolbar: false, // ツールバーの非表示
    // smallBtn: true, // 小さいCloseボタン利用する
    // iframe: {
    //   // iframe 関連の処理
    //   preload: false, //iframeのプリロードをしない
    // },
  });
}

// Blobs写真切り替わり
function setBlobsSlide(timeOut) {
  var timeOut = timeOut;
  var time = setInterval(slideChange_01, timeOut);
  // var timer_01;
  // var timer_02;
  // var timer_03;
  // var timer_04;

  function slideChange_01() {
    clearInterval(time);
    // clearTimeout(timer_03);
    // clearTimeout(timer_04);
    $('.autoslide_01 .item:last-child').addClass('active');
    // timer01 = setTimeout(function () {
    //   $('.autoslide_02 .item:last-child').addClass('active');
    // }, 2000);
    // timer02 = setTimeout(function () {
    //   $('.autoslide_03 .item:last-child').addClass('active');
    // }, 4000);
    // time = setInterval(slideChange_02, timeOut);
  }
  // function slideChange_02() {
  //   clearInterval(time);
  //   clearTimeout(timer_01);
  //   clearTimeout(timer_02);
  //   $('.autoslide_01 .item:last-child').removeClass('active');
  //   timer03 = setTimeout(function () {
  //     $('.autoslide_02 .item:last-child').removeClass('active');
  //   }, 2000);
  //   timer04 = setTimeout(function () {
  //     $('.autoslide_03 .item:last-child').removeClass('active');
  //   }, 4000);
  //   time = setInterval(slideChange_01, timeOut);
  // }
}

//宿泊予約ボタン制御
function setReserveBtn() {
  $('.headReserveBtn').on('click', function () {
    if (!$(this).hasClass('is-active')) {
      $(this).addClass('is-active');
      $('.headSearch').slideDown(300);
      $('#wrapper').addClass('searchOpen');
    } else {
      $(this).removeClass('is-active');
      $('.headSearch').slideUp('fast');
      $('#wrapper').removeClass('searchOpen');
      $('.headSearchNav li.tab_00').click();
    }
  });
  $('#clickBlocker').on('click', function () {
    $('.headReserveBtn').removeClass('is-active');
    $('.headSearch').slideUp('fast');
    $('#wrapper').removeClass('searchOpen');
    $('.headSearchNav li.tab_00').click();
  });
}

//検索タブ制御
function setSearchTab() {
  $('.headSearchNav li').on('click', function () {
    if (!$(this).hasClass('is-active')) {
      $('.headSearchNav li').removeClass('is-active');
      $('.searchContent').removeClass('is-active');
      $('.searchContent').hide();
      let target = '#' + $(this).attr('class').replace(' is-active');
      $(target).fadeIn();
      $(this).addClass('is-active');
      $('.headSearchNav').removeClass('is-active');
    }
  });
  $('.searchHubSection .tab_02').on('click', function () {
    $('.headSearchNav li').removeClass('is-active');
    $('.searchContent').removeClass('is-active');
    $('.searchContent').hide();
    let target = '#' + $(this).attr('class');
    $(target).fadeIn();
    $('.headSearchNav li.tab_02').addClass('is-active');
    $('.headSearchNav').addClass('is-active');
  });
}

//デートピッカー
function setDatePicker() {
  $('.datePicker').datepicker({
    minDate: 0, // 今日の日付より前は選択不可
  });

  //チェックインの日付設定
  // 現在の日付を取得
  var today = new Date();
  var todayOut = new Date();

  // 現在の日付に60日を追加
  var futureDate = new Date(today.setDate(today.getDate() + 60));
  var futureDateOut = new Date(todayOut.setDate(todayOut.getDate() + 61));

  // YYYY/MM/DD形式に変換する関数
  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('/');
  }

  // クラス名に基づいて全ての対象要素に日付を設定
  var inputs = document.getElementsByClassName('futureDateInput');
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].value = formatDate(futureDate);
  }

  var inputs = document.getElementsByClassName('futureDateInput-out');
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].value = formatDate(futureDateOut);
  }
}

//メアドスパム対策
function mailTo() {
  $('.mailTo').click(function () {
    var address = $(this).attr('href').replace('+', '@');
    location.href = 'mailto:' + address;
    return false;
  });
}

// Rellax
function setRellax() {
  var rellax = new Rellax('.js-rellax');
}

// カルーセル
function setSlider_01() {
  const mySwiperMain = new Swiper('.carouselStyle_01 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    loop: true,
    effect: 'fade',
    // preventClicks: false,
    // preventClicksPropagation: false,
    autoplay: {
      // 自動再生
      delay: 8000, // 1.5秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    mousewheel: {
      forceToAxis: true,
    },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   draggable: true,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, // クリック有効化
      type: 'fraction',
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    // breakpoints: {
    //   769: {
    //     slidesPerView: 5,
    //     spaceBetween: 36,
    //   },
    //   // 1000: {
    //   //   slidesPerView: 3,
    //   //   spaceBetween: 30,
    //   // },
    // },
  });
}

function setSlider_02() {
  const mySwiperMain = new Swiper('.carouselStyle_02 .swiper-main', {
    slidesPerView: 1.5,
    spaceBetween: 14,
    threshold: 10,
    // loop: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      769: {
        spaceBetween: 20,
        slidesPerView: 3.5,
      },
      1300: {
        spaceBetween: 20,
        slidesPerView: 4.5,
      },
    },
  });
  heightLineGroup();
}

function setSlider_03() {
  const mySwiperMain = new Swiper('.carouselStyle_03 .swiper-main', {
    slidesPerView: 'auto', //variablewidthにするため､autoを指定
    // centeredSlides: true, //スライドを中央に寄せる
    spaceBetween: 14,
    threshold: 10,
    // loop: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      769: {
        spaceBetween: 20,
        // slidesPerView: 3.5,
      },
      1300: {
        spaceBetween: 20,
        // slidesPerView: 4,
      },
    },
  });
  heightLineGroup();
}

function setSlider_04() {
  const mySwiperMain = new Swiper('.carouselStyle_04 .swiper-main', {
    slidesPerView: 1.5,
    centeredSlides: true, //スライドを中央に寄せる
    spaceBetween: 14,
    threshold: 10,
    loop: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      769: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });
  heightLineGroup();
}

function setSlider_05() {
  const mySwiperMain = new Swiper('.carouselStyle_04 .swiper-main', {
    slidesPerView: 1.5,
    initialSlide: 1,
    centeredSlides: true, //スライドを中央に寄せる
    spaceBetween: 14,
    threshold: 10,
    // loop: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      769: {
        centeredSlides: false, //スライドを中央に寄せる
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });
  heightLineGroup();
}

function setSlider_06() {
  const mySwiperMain = new Swiper('.carouselStyle_05 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    loop: true,
    effect: 'fade',
    autoplay: {
      // 自動再生
      delay: 8000, // 1.5秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('.mainMenuBtn').on('click', function () {
    if (!$('.mainMenuBtn').hasClass('active')) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  $('.menuOpen #clickBlocker,.menuCloseArea').on('click', function (event) {
    event.stopPropagation();
    closeFnc();
  });

  // $('.mainNav a').on('click', function (event) {
  //   event.stopPropagation();
  // });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('.mainMenuBtn').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('.headReserveBtn').removeClass('is-active');
  $('.headSearch').slideUp('fast');
  $('#wrapper').removeClass('searchOpen');
  $('.headSearchNav li.tab_00').click();
  if ($('#wrapper').hasClass('setSp')) {
    $('#outerMenu').css('top', -current_scrollY);
  }
}

function closeFnc() {
  $('.mainMenuBtn').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  if ($('#wrapper').hasClass('setSp')) {
    $('html, body').prop({
      scrollTop: current_scrollY,
    });
  }
}

// //////////////////////////モーダル
function setModal() {
  $('.pinModal').on('click', function (event) {
    let target = '.' + $(this).find('span').attr('class');
    $('#modalWrapper').find('.content').removeClass('active');
    $('#modalWrapper').find(target).addClass('active');
    openModal();
  });

  $('.modalCloseArea,#clickBlocker,.modalCloseBtn').on('click', function (event) {
    event.stopPropagation();
    closeModal();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeModal();
      }
    }, 200);
  });
}

function openModal() {
  current_scrollY = $(window).scrollTop();
  $('.modalSec').fadeIn();
  $('#wrapper').addClass('modalOpen');
  if ($('#wrapper').hasClass('setSp')) {
    $('#outerMenu').css('top', -current_scrollY);
  }
}

function closeModal() {
  $('.modalSec').hide();
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('modalOpen');
  if ($('#wrapper').hasClass('setSp')) {
    $('html, body').prop({
      scrollTop: current_scrollY,
    });
  }
}

// ///////ヘッダー制御
let set_position = 0;
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    if ($('#wrapper').hasClass('home')) {
      h = $('#mainVis').height() / 2;
    } else if ($('#wrapper').hasClass('setKv')) {
      h = $('#kv').height();
    } else {
      h = 5;
    }
    baseHeight = h;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
    if (set_position < $(this).scrollTop()) {
      $('#wrapper').addClass('scrollDown');
      $('#wrapper').removeClass('scrollUp');
    } else {
      $('#wrapper').addClass('scrollUp');
      $('#wrapper').removeClass('scrollDown');
    }

    set_position = $(this).scrollTop();
  }
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way,.autoWay').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.js-item-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.video-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      var videoElem = activePoint.find('video');
      if (direction === 'down') {
        videoElem.get(0).play();
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.js-toggle .head').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle(600);
  });
  $('.js-toggle_02 .head').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
  $('.faqSec .head').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
  $('.specAcc .head').on('click', function () {
    $(this).parent().toggleClass('toggleActive');
    $(this).next().stop().slideToggle('fast');
  });
  $('.aboutBtn').on('click', function () {
    var btn = $(this);
    var wrap = btn.closest('.aboutIntroWrap');
    var targetItems = wrap.find('.aboutIntroItem').not('.showItem');
    var isOpen = btn.hasClass('is-open');
    var lang = ($('html').attr('lang') || '').toLowerCase();
    var isEnglishLocale =
      $('#wrapper').hasClass('en-US') || $('body').hasClass('en-US') || lang === 'en-us';

    btn.toggleClass('is-open', !isOpen);
    btn
      .find('.labelTx')
      .text(
        isOpen
          ? isEnglishLocale
            ? 'View All'
            : 'すべて見る'
          : isEnglishLocale
            ? 'Close'
            : '閉じる'
      );
    targetItems.stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
    $('#mainVis').addClass('is-active');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  var headerHeight = $('header').height();
  // var headerHeight = $('header .col-main').height() + 50;
  // if ($('#wrapper').hasClass('setPc')) {
  //   var headerHeight = 0;
  // } else {
  //   var headerHeight = 100;
  // }
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;

    if ($(this).hasClass('unqNav')) {
      closeModal();
    }
    setTimeout(function () {
      var position = target.offset().top - headerHeight;
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }, 100);
    e.preventDefault();
    // $.when(
    //   $('html, body').animate(
    //     {
    //       scrollTop: position,
    //     },
    //     400,
    //     'swing'
    //   ),
    //   e.preventDefault()
    // ).done(function () {
    //   var diff = target.offset().top;
    //   if (diff === position) {
    //   } else {
    //     $('html, body').animate(
    //       {
    //         scrollTop: diff,
    //       },
    //       400,
    //       'swing'
    //     );
    //   }
    // });
  });
}

function startScroll() {
  // ページのURLを取得
  const url = window.location.href,
    // headerの高さを取得してそれに100px追加した値をheaderHeightに代入
    headerHeight = document.querySelector('header').offsetHeight + 100;

  // URLに「#」が含まれていれば
  if (url.includes('#')) {
    // URLを#で分割して配列に格納
    const anchor = url.split('#'),
      // 分割した最後の文字列（#◯◯の部分）をtargetIdに代入
      targetId = anchor[anchor.length - 1],
      target = document.getElementById(targetId);

    if (target) {
      // リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
      const position =
        Math.floor(target.getBoundingClientRect().top + window.pageYOffset) - headerHeight;

      // スムーズスクロールを実行
      window.scrollTo({ top: position, behavior: 'smooth' });

      // URLに「#point_01」が含まれている場合、#point_01 .headをクリック
      if (targetId === 'point_01') {
        const head = target.querySelector('.head');
        if (head) {
          head.click();
        }
      }
    }
  }
  setScroll(); // 既存のsetScroll関数を呼び出し
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

function watchViewMode() {
  window.addEventListener('orientationchange', function () {
    // orientationchange イベントがトリガーされたときの処理をここに記述します
    location.reload(); // ページをリロードします
  });
}
// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  setAutoHeight('.setH_01');
  setAutoHeight('.setH_02');
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.setH_03 .summary', 3);
    setAutoHeight('.setH_04', 2);
  }

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
